(() => {
  if (window.__fmCanAddOnReady) return;
  window.__fmCanAddOnReady = true;

  const variantId = 64995547447673;
  const threshold = 52000;
  const qualifyingProductIds = new Set([15414203056505, 15414203089273, 15421828268409, 15421820371321, 15414202990969, 15800043209081, 15435369087353, 15414203122041, 15884462260601, 15475940000121, 15414202958201, 15414202892665, 15856894640505, 15475942326649, 15414202859897, 15414202827129, 15414202794361, 15414202761593, 15897109037433, 15897108873593, 15897108742521, 15897108578681, 15897108447609, 15897108251001, 15897108119929, 15897107956089, 15897107759481, 15897107366265, 15897107202425, 15897107038585, 15897106874745, 15897106678137, 15897105793401, 15897105662329, 15897105531257, 15897105400185, 15897105269113, 15897105105273, 15897104908665, 15897104318841, 15896880841081, 15896880316793, 15886030537081, 15886030504313, 15886030438777, 15884470976889, 15871853625721, 15864445141369, 15864444322169, 15864063361401, 15863899062649, 15856894837113, 15856894804345, 15856894771577, 15856894706041, 15856894673273, 15856894607737, 15475941572985, 15475941343609, 15435374199161, 15421828956537, 15421828792697, 15421828301177, 15421828202873, 15421828104569, 15421821321593, 15414203023737]);

  const getHosts = () => {
    const hosts = [...document.querySelectorAll('[data-fm-bag-offers]')];
    const pageHost = [...document.querySelectorAll('.cart-totals')].find((host) => !host.closest('cart-drawer-component, .cart-drawer')); 
    if (pageHost) hosts.push(pageHost);
    return hosts;
  };

  const getCard = (host) => {
    let card = host.querySelector(':scope > [data-fm-can-addon]');
    if (card) return card;
    card = document.createElement('section');
    card.dataset.fmCanAddon = 'true';
    card.className = 'fm-can-addon';
    if (host.matches('.cart-totals')) host.insertBefore(card, host.querySelector('.cart-actions') || host.firstChild);
    else host.prepend(card);
    return card;
  };

  const lockCanQuantity = () => {
    document.querySelectorAll('a[href*="variant=' + variantId + '"]').forEach((link) => {
      const line = link.closest('tr, .cart-item, cart-item');
      if (!line) return;
      const increase = [...line.querySelectorAll('button')].find((button) => /增加數量/.test(button.textContent || ''));
      if (increase) {
        increase.disabled = true;
        increase.setAttribute('aria-label', '加購肉罐每單限 1 罐');
      }
      const input = line.querySelector('input[type="number"]');
      if (input) input.max = '1';
    });
  };

  const hasBundleDiscount = (cart) => {
    const cartDiscount = cart.items.some((item) =>
      (item.line_level_discount_allocations || item.discount_allocations || []).some((allocation) =>
        /零食自由搭配|滿5包/i.test(allocation.discount_application?.title || allocation.title || '')
      )
    );
    const pageClone = document.body.cloneNode(true);
    pageClone.querySelectorAll('[data-fm-can-addon]').forEach((node) => node.remove());
    return cartDiscount || /本單食品已享\s*9\s*折|零食自由搭配.*滿5包/i.test(pageClone.textContent || '');
  };

  const renderCard = (card, state, html) => {
    if (card.dataset.fmState === state) return;
    card.dataset.fmState = state;
    card.hidden = false;
    card.innerHTML = html;
    if (state !== 'eligible') return;
    card.querySelector('[data-fm-can-add]').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      button.disabled = true;
      button.textContent = '加入中';
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (response.ok) location.reload();
      else {
        button.disabled = false;
        button.textContent = '加購 $20';
      }
    }, { once: true });
  };

  const render = async () => {
    const hosts = getHosts();
    if (!hosts.length) return;
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json());
      if (!cart.item_count) { hosts.forEach(host=>{const card=host.querySelector('[data-fm-can-addon]');if(card)card.hidden=true;}); return; }
      const hasCan = cart.items.some((item) => item.variant_id === variantId);
      const hasBundle = hasBundleDiscount(cart);
      const eligibleTotal = cart.items
        .filter((item) => item.variant_id !== variantId && qualifyingProductIds.has(item.product_id))
        .reduce((sum, item) => sum + (item.original_line_price || item.final_line_price), 0);

      lockCanQuantity();
      hosts.forEach((host) => {
        const card = getCard(host);
        if (hasBundle) {
          renderCard(card, 'bundle', '<strong>本單已使用五包九折</strong><p>優惠擇一，罐頭加購不併用</p>');
        } else if (hasCan) {
          renderCard(card, 'added', '<strong>罐頭加購已在購物車</strong><p>符合門檻後，結帳自動折 $5</p>');
        } else if (eligibleTotal < threshold) {
          const gap = Math.ceil((threshold - eligibleTotal) / 100);
          renderCard(card, 'locked', '<strong>滿 $520 可加購肉罐 $20</strong><p>再選 $' + gap + ' 即可解鎖怪獸部落鮮雞絲 80g</p>');
        } else {
          renderCard(card, 'eligible', '<div><strong>加購怪獸部落鮮雞絲 80g</strong><p>原價 $25　加購價 $20　每單限 1 罐</p></div><button type="button" data-fm-can-add>加購 $20</button>');
        }
      });
    } catch (_) {
      getHosts().forEach((host) => {
        const card = host.querySelector(':scope > [data-fm-can-addon]');
        if (card) card.hidden = true;
      });
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      render();
    });
  };

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:update', schedule);
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => !(mutation.target instanceof Element) || !mutation.target.closest('[data-fm-can-addon]'))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  render();
})();
;(() => {
  if (window.__furmosaCartClarityReady) return;
  window.__furmosaCartClarityReady = true;
  let scheduled = false;

  function setText(node, value) {
    if (node && value && node.textContent !== value) node.textContent = value;
  }

  function clarify(drawer) {
    if (!drawer.matches('[data-fm-bag]')) return;
    const offers = drawer.querySelector('[data-fm-bag-offers]');
    const target = offers?.querySelector('[data-fm-bag-native-actions]');
    const actions = drawer.querySelector('.cart-actions');
    if (target && actions && actions.parentElement !== target) target.append(actions);
    const labels = drawer.querySelector('[data-fm-bag-labels]')?.dataset;
    if (labels) {
      setText(drawer.querySelector('.cart-totals__total-label'), labels.total);
      setText(drawer.querySelector('.cart-totals__tax-note'), labels.shipping);
      setText(drawer.querySelector('.cart-discount__label'), labels.code);
    }
    offers?.querySelectorAll('.cart-discount details').forEach((details) => {
      if (!details.open) details.open = true;
    });
    drawer.querySelectorAll('.cart-items__title').forEach((node) => {
      const text = node.textContent.replace(/[◇◈]/g, '').replace(/\s{2,}/g, ' ').trim();
      setText(node, text);
    });
    const button = drawer.querySelector('.cart__checkout-button');
    if (button) {
      if (!button.disabled && labels?.checkout) setText(button.querySelector('.button-text'), labels.checkout);
      if (offers?.dataset.addonInvalid === 'true') {
        button.disabled = true;
        button.dataset.fmBagInvalid = 'true';
      } else if (button.dataset.fmBagInvalid === 'true') {
        button.disabled = false;
        delete button.dataset.fmBagInvalid;
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('cart-drawer-component[data-fm-bag]').forEach(clarify);
    });
  }

  function install() {
    document.querySelectorAll('cart-drawer-component[data-fm-bag]').forEach((drawer) => {
      if (drawer.dataset.fmBagReady) return;
      drawer.dataset.fmBagReady = 'true';
      drawer.addEventListener('click', (event) => {
        const done = event.target.closest?.('[data-fm-bag-done]');
        if (!done) return;
        const details = done.closest('details');
        details.open = false;
        details.querySelector('summary').focus();
      });
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
      clarify(drawer);
    });
  }

  document.addEventListener('cart:update', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('shopify:section:load', install);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();

